import useGravitySensor from 'react-hook-gravity'

const GravityRealHookDemo = props => {
  const sensor = useGravitySensor({ frequency: 2 })
  console.log(sensor)
  return (
    <div>
      <div>useGravitySensor Real Hook Demo</div>
      <pre>{JSON.stringify(sensor, null, 2)}</pre>
    </div>
  )
}

export default GravityRealHookDemo
